import React from 'react';
import ReactDOM from 'react-dom';
import './styles.css';
import Group from "./Group";

ReactDOM.render(
	<React.StrictMode>
		<Group/>
	</React.StrictMode>,
	document.getElementById( 'root' )
);
